{
  "TelnosmovedtoLabel": "Telefonnummer(n) verschoben nach:",
  "DevicesmovedfromLabel": "Gerät(e) verschoben von:",
  "AcdagentsmovedfromLabel": "ACD-Agent(en) verschoben von:",
  "CallsegmentnumberLabel": "Anrufsegmentnummer:",
  "CallsegmentnumberAnyOptionLabel": "[Irgendein]",
  "CallsegmentnumberFirstOptionLabel": "[Zuerst]",
  "Callsegmentnumber2OptionLabel": "2",
  "Callsegmentnumber3OptionLabel": "3",
  "Callsegmentnumber4OptionLabel": "4",
  "Callsegmentnumber5OptionLabel": "5",
  "Callsegmentnumber6plusOptionLabel": "6+",
  "CallsegmentnumberLastOptionLabel": "[Letzte]",
  "CallsegmentstartreasonLabel": "Startgrund für Anrufsegment:",
  "CallsegmentstartreasonAnyOptionLabel": "[Irgendein]",
  "CallsegmentstartreasonDivertedtoOptionLabel": "Umgeleitet zu",
  "CallsegmentstartreasonOverflowedinOptionLabel": "Eingelaufen",
  "CallsegmentstartreasonAdvancedtoOptionLabel": "Erweitert zu",
  "CallsegmentstartreasonTransferredtoOptionLabel": "Übertragen auf",
  "CallsegmentstartreasonConferencedtoOptionLabel": "Konferenz zu",
  "CallsegmentstartreasonConferencedegenOptionLabel": "Konferenz De\/Gen",
  "CallsegmentendreasonLabel": "Grund für das Ende des Anrufsegments:",
  "CallsegmentendreasonAnyOptionLabel": "[Irgendein]",
  "CallsegmentendreasonDivertedfromOptionLabel": "Umgeleitet von",
  "CallsegmentendreasonOverflowedoffOptionLabel": "Überlauf Aus",
  "CallsegmentendreasonAdvancedfromOptionLabel": "Erweitert von",
  "CallsegmentendreasonTransferredfromOptionLabel": "Transferiert von",
  "CallsegmentendreasonConferencedfromOptionLabel": "Konferenz von",
  "CallsegmentendreasonConferencedegenOptionLabel": "Konferenz De\/Gen",
  "CallsegmentendreasonConsultationtrtoOptionLabel": "Rücksprache Tr\/To",
  "CallsegmentendreasonMovedtoconferenceOptionLabel": "Zur Konferenz verschoben",
  "CallsegmentendreasonMovedtoparkOptionLabel": "In den Park verlegt",
  "CallsegmentendreasonMovedtovoicemailOptionLabel": "In Voicemail verschoben",
  "CallsegmentendreasonEndedonholdonlyOptionLabel": "Beendet nur in Wartestellung",
  "CallsegmentendreasonEndedonholdexclOptionLabel": "Beendete Warteschleife ausgeschlossen",
  "CallsegmentendreasonUnmonitoreddestOptionLabel": "Nicht überwachtes Ziel",
  "CallsegmentendreasonUnknowndestOptionLabel": "Unbekanntes Ziel",
  "CallsegmentendreasonAllunrslvddestonlyOptionLabel": "Nur alle nicht aufgelösten Ziele",
  "CallsegmentendreasonAllunrslvddestexclOptionLabel": "Alle nicht aufgelösten Ziele ausgeschlossen",
  "CallsegmentendreasonModellingerrorsonlyOptionLabel": "Nur Modellierungsfehler",
  "CallsegmentendreasonModellingerrorsexclOptionLabel": "Modellierungsfehler ausgeschlossen",
  "CallsegmentendreasonApplicationendedOptionLabel": "Anwendung beendet",
  "CallsegmentendreasonDevicedeletedOptionLabel": "Gerät gelöscht",
  "CallsegmentendreasonNoreplyneededEmailsexcludedOptionLabel": "Keine Antwort erforderlich E-Mails ausgeschlossen",
  "CallsegmentchainidLabel": "Anrufsegmentketten-ID (Anwendungsanruf-ID):",
  "CallMovementFiltering_SectionHeader": "Bewegungsfilterung aufrufen",
  "CallMovementFiltering_AnyPlaceholder": "[Irgendein]",
  "NAME": "CallMovementFiltering",
  "AcdagentsmovedfromLabel_MST": "Agent(en) umgezogen von:",
  "CallsegmentstartreasonEscapedtoOptionLabel": "Geflüchtet nach",
  "CallsegmentendreasonEscapedfromOptionLabel": "Geflohen"
}